import { OPTIMISER_RUN_STATUS as types } from 'actions/actionTypes';
import { read, write } from './finishedRunsStorage';

const MAX_FINISHED_RUNS = 50;

export const initialState = {
  runStatus: {
    state: 'unknown',
    activeRuns: [],
    recentTerminalRuns: [],
    finishedWindowSeconds: 600,
    tenancyId: null
  },
  runHistory: {
    results: [],
    inFlight: false,
    error: null
  },
  optimiserFinishedRuns: read(),
  inFlight: false,
  error: null
};

export const optimiserRunStatus = (state = initialState, action) => {
  switch (action.type) {
  case types.LOAD_IN_FLIGHT: {
    return { ...state, inFlight: true, error: null };
  }
  case types.LOAD_SUCCESS: {
    const { data } = action;
    const mapRun = run => ({
      runIdentifier: run.run_identifier || '',
      runName: run.run_name || '',
      state: run.state || 'unknown',
      rawStatus: run.raw_status || '',
      fromDate: run.from_date || null,
      toDate: run.to_date || null,
      triggeredAt: run.triggered_at || null,
      receivedAt: run.received_at || null
    });
    const mapTerminalRun = run => ({
      ...mapRun(run),
      message: run.message || '',
      finishedAt: run.finished_at || null
    });
    return {
      ...state,
      inFlight: false,
      runStatus: {
        state: data.state || 'unknown',
        activeRuns: Array.isArray(data.active_runs) ? data.active_runs.map(mapRun) : [],
        recentTerminalRuns: Array.isArray(data.recent_terminal_runs)
          ? data.recent_terminal_runs.map(mapTerminalRun)
          : [],
        finishedWindowSeconds: data.finished_window_seconds || 600,
        tenancyId: data.tenancy_id || null
      }
    };
  }
  case types.LOAD_FAILURE: {
    return { ...state, inFlight: false, error: action.error };
  }
  case types.HISTORY_IN_FLIGHT: {
    return { ...state, runHistory: { ...state.runHistory, inFlight: true, error: null } };
  }
  case types.HISTORY_SUCCESS: {
    const rows = Array.isArray(action.data) ? action.data : [];
    return {
      ...state,
      runHistory: {
        inFlight: false,
        error: null,
        results: rows.map(row => ({
          id: row.id,
          receivedAt: row.received_at || null,
          result: row.result || '',
          fromDate: row.from_date || null,
          toDate: row.to_date || null,
          message: row.message || ''
        }))
      }
    };
  }
  case types.HISTORY_FAILURE: {
    return { ...state, runHistory: { ...state.runHistory, inFlight: false, error: action.error } };
  }
  case types.OBSERVE_FINISHED_RUN: {
    const { runIdentifier, receivedAt } = action;
    // Dedup by (runIdentifier, receivedAt): the same run finishing again later
    // carries a newer receivedAt (server-enforced, see the backend freshness
    // guard) and must still notify, so runIdentifier alone is not enough.
    if (!runIdentifier || state.optimiserFinishedRuns.some(
      r => r.runIdentifier === runIdentifier && r.receivedAt === receivedAt
    )) {
      return state;
    }
    const record = {
      runIdentifier,
      receivedAt: receivedAt || null,
      state: action.state || 'finished',
      runName: action.runName || '',
      fromDate: action.fromDate || null,
      toDate: action.toDate || null,
      message: action.message || '',
      acknowledged: false
    };
    const optimiserFinishedRuns = state.optimiserFinishedRuns
      .concat(record)
      .slice(-MAX_FINISHED_RUNS);
    write(optimiserFinishedRuns);
    return { ...state, optimiserFinishedRuns };
  }
  case types.ACKNOWLEDGE_RUN: {
    const { runIdentifier, receivedAt } = action;
    const matches = r => r.runIdentifier === runIdentifier && r.receivedAt === receivedAt;
    if (!state.optimiserFinishedRuns.some(r => matches(r) && !r.acknowledged)) {
      return state;
    }
    const optimiserFinishedRuns = state.optimiserFinishedRuns.map(r => (
      matches(r) ? { ...r, acknowledged: true } : r
    ));
    write(optimiserFinishedRuns);
    return { ...state, optimiserFinishedRuns };
  }
  default:
    return state;
  }
};

export default optimiserRunStatus;
